
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newoffer",
      function () {
        return require("private-next-pages/newoffer/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newoffer"])
      });
    }
  